import { render, staticRenderFns } from "./newsAdd.vue?vue&type=template&id=3d8256f4&"
import script from "./newsAdd.vue?vue&type=script&lang=js&"
export * from "./newsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports